module.exports = __webpack_public_path__ + "static/cercazone_hero3-d97d8442c8a3b987f098967c75e0943c.jpg";